angular.module('kareo.ui.shared.modules.iframe-modal-service', [])
.service "IFrameModalService", ['$rootScope', '$q', ($rootScope, $q) ->
  activeModal = null

  createModalContainer = (frame, transparentBackground) ->
    container = angular.element("<div class=\"lightbox\"></div>").append(frame)
    if(transparentBackground)
      container.css("background", "none")
    container

  setFrameBodyStyles = (frame) ->
    #frame should be 100% and transparent background
    iFrameBody = frame.contents().find("body")
    iFrameBody.css "background-color", "transparent"
    iFrameBody.css "margin", 0

  setFrameStyles = (frame, iframeCssClass) ->
    frame.css "vertical-align", "top"
    frame.css "border", "none"

    if iframeCssClass
      frame.addClass iframeCssClass
    else
      frame.css "height", "100%"
      frame.css "width", "100%"

  onLoad = ->
    if(!activeModal.loaded)
      activeModal.container.toggleClass "open"
      setFrameBodyStyles activeModal.frame

  createModalFrame = (url) ->
    frame = angular.element("<iframe src=\"" + url + "\">")
    frame.on "load", onLoad

    frame

  closeFrame = ->
    activeModal.container.remove()

  close = (data) ->
    $rootScope.$apply ->
      activeModal.deferred.resolve data
      closeModal()

  cancel = ->
    $rootScope.$apply ->
      activeModal.deferred.reject()
      closeModal()

  closeModal = ->
    closeFrame()
    activeModal = null

  createModalService = ->
    service = {}
    service.close = close
    service.cancel = cancel
    service

  attachModalService = (frame, modalService) ->
    frame.contentWindow.ModalService = modalService

  open = (url, transparent, iframeCssClass) ->
    if(activeModal?.url == url)
      return activeModal.deferred.promise
    else if activeModal
      throw new Error("modal already active. Active: " + activeModal.url + ' - ' + 'Requested ' + url)
    deferred = $q.defer()

    activeModal = {}
    activeModal.url = url;
    activeModal.deferred = deferred
    activeModal.frame = createModalFrame(url)
    setFrameStyles activeModal.frame, iframeCssClass
    activeModal.container = createModalContainer(activeModal.frame, transparent)
    activeModal.loaded = false;

    angular.element(document.body).append activeModal.container

    attachModalService activeModal.frame[0], createModalService()

    deferred.promise


  open: open
  close: close
  cancel: cancel

]

